import useHttpLoader from '../../../../../../shared/hooks/useHttpLoader.ts'
import useStateWithChange from '../../../../../../shared/hooks/useStateWithChange.ts'
import FormField from '../../../../../../shared/Forms/FormField'
import TextInput from '../../../../../../shared/Inputs/TextInput'
import SeparateLine from '../../../../../../shared/Forms/SeparateLine'
import SidePage from '../../../../../../shared/SidePage'
import Button from '../../../../../../shared/Buttons/Button'
import { TCreateEquipmentModelDTO } from '../../equipmentModels.types.ts'
import equipmentModelsApi from '../../equipmentModels.api.ts'
import equipmentEvents from '../../../../events/equipment/equipment.events.ts'

interface IProps {
  onClose: () => void
  open: boolean
}

const CreateEquipmentModelSidePage = (props: IProps) => {
  const { wait, loading } = useHttpLoader()
  const [model, _, handleChange] = useStateWithChange<TCreateEquipmentModelDTO>({ name: '' })

  const handleSave = () => {
    wait(equipmentModelsApi.createModel(model), (resp) => {
      if (resp.status === 'success') {
        equipmentEvents.modelCreated(resp.body)
        props.onClose()
      }
    })
  }

  return (
    <SidePage onClose={props.onClose} open={props.open}>
      <div className="flex-lines gap16" style={{ height: '100%' }}>
        <h2 className="text-heading-4">Создание модели оборудования</h2>
        <SeparateLine />
        <FormField label="Наименование" required={true}>
          <TextInput value={model.name} name="name" onChange={handleChange} placeHolder="Введите наименование" />
        </FormField>

        <div style={{ marginTop: 'auto' }}>
          <SeparateLine />
        </div>
        <div className="inline-flex-gap gap8">
          <Button size="default" type="primary" text="Создать" onClick={handleSave} loading={loading} />
          <Button size="default" type="default" text="Отменить" onClick={props.onClose} disabled={loading} />
        </div>
      </div>
    </SidePage>
  )
}

export default CreateEquipmentModelSidePage
